import { Component } from '@angular/core';

@Component({
  selector: 'app-kanban-shimmer',
  templateUrl: './kanban-shimmer.component.html',
  styleUrl: './kanban-shimmer.component.css'
})
export class KanbanShimmerComponent {
  shimmerColumns = [1, 2, 3, 4,5]; 
  shimmerCards = [1, 2, 3];
}
